import * as React from 'react';
import { PaginationEllipsis } from '@/web/components/ui/pagination';

export function PaginationEllipsisButton(props: React.ComponentProps<'button'>): React.ReactElement {
  return (
    <button
      type="button"
      className="flex h-9 w-9 items-center justify-center cursor-pointer"
      {...props}
    >
      <PaginationEllipsis />
    </button>
  );
}
